export default __webpack_public_path__ + "static/media/Hauora-Bold.cd1a7872.woff2";